import script from "./marketManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./marketManager.vue?vue&type=script&lang=ts&setup=true"

import "./marketManager.vue?vue&type=style&index=0&id=55c69236&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c69236"]])

export default __exports__